import { IonContent, isPlatform } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { FormInput } from '@/components/FormInput';
import { InfoProtection } from '@/components/InfoProtection';
import { S3_BUCKET_URL } from '@/constants.ts';
import { useAccount } from '@/hooks/useAccount';
import { useCreateStripeClient } from '@/hooks/useCreateStripeClient';
import { OnboardingSubtitle } from '@/pages/Onboarding/components/Subtitle';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';
import { checkIsValidateEmail } from '@/pages/Onboarding/utils/checkIsValidEmail';
import { userService } from '@/services/user';
import { trackOnboardingComplete } from '@/utils/analytics';

import { LayoutDataType } from '../../types';

import { Image, PageStyles } from './Email.styles';

export const ScreenEmail: React.FC = () => {
  const form = useFormContext<LayoutDataType>();

  const { refreshUser } = useAccount();

  const inputRef = React.useRef<HTMLIonInputElement>(null);

  const formEmail = form.watch('email');

  const isValidEmail = checkIsValidateEmail(formEmail);

  const { createStripeClient, isCreatingStripeClient } =
    useCreateStripeClient();

  React.useEffect(() => {
    if (isPlatform('android') || isPlatform('desktop')) {
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.setFocus();
        }
      });
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.setFocus();
        }
      }, 1000);
    }
  }, []);

  const handleNextStep = async (): Promise<void> => {
    if (!formEmail || !isValidEmail) return;

    try {
      const lowerCaseEmail = formEmail.toLowerCase().trim();

      trackOnboardingComplete({ email: lowerCaseEmail });

      await Promise.all([
        createStripeClient(lowerCaseEmail),
        userService.createOrUpdate({
          onboarding_data: {
            onboarded: true,
          },
        }),
      ]);

      refreshUser();
    } catch (error) {
      console.error('Can not create a stripe user', error);
    }
  };

  return (
    <PageStyles background="dark-forest">
      <IonContent>
        <Image src={`${S3_BUCKET_URL}/layout-own-ai-man-roleplay/email.png`} />
        <div className={'content'}>
          <OnboardingTitle className="onboarding-email-title">
            You are almost there!
          </OnboardingTitle>
          <OnboardingSubtitle>
            Don’t stop now — leave your email to continue the story.
          </OnboardingSubtitle>
          <div className="email-input-container">
            <FormInput
              form={form}
              hidden={false}
              onSubmit={handleNextStep}
              isShowButton={isValidEmail}
              ref={inputRef}
              name="email"
              type="email"
              placeholder="example@site.com"
              loading={isCreatingStripeClient}
              theme={'roleplay'}
            />
          </div>
          <div className="email-protection">
            <InfoProtection />
          </div>
        </div>
      </IonContent>
    </PageStyles>
  );
};
